


































import { Dictionary } from '@empathy/search-adapter';
import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, Store } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { DiscoveryWallBlockConfig, EmpathyXConfig, ResultConfig } from '../../models';
import { GETTERS_KEYS, RootStoreState } from '../../store';
import { VueCssClasses } from '../../utils';

@Component({
  computed: {
    ...mapGetters({
      config: GETTERS_KEYS.config.config,
      resultsConfig: GETTERS_KEYS.config.discoveryWallResultsConfig
    })
  }
})
export default class DiscoveryWallBlock extends Vue {
  config: EmpathyXConfig;
  resultsConfig: ResultConfig;
  $store: Store<RootStoreState>;

  @Prop({ required: true })
  blockName: string;

  @Prop({ required: true })
  blockConfig: DiscoveryWallBlockConfig;

  get results(): Dictionary<Result[]> {
    return this.$store.getters[this.blockConfig.resultsGetter];
  }

  get cssClasses(): VueCssClasses {
    return [`ebx-discovery-wall-block--${ this.blockName }`];
  }

  get panelName(): string {
    return `discovery-wall-${ this.blockName }`;
  }

  get title(): string {
    return this.$x.messages.discoveryWall[this.blockName];
  }

  get titleParams(): Dictionary<string> {
    const section = this.$store.state.config.dynamic.section;
    return {
      section: this.$x.messages.sections[section] || section
    };
  }

  mounted(): void {
    this.$x.emit(EVENTS.DiscoveryWallBlockShow, this.blockName);
  }
}
